// extracted by mini-css-extract-plugin
export var marginNegative = "_5f-5 _5f-3 _5f-1";
export var marginPositive = "_5f-4 _5f-3 _5f-1";
export var modalContent = "_5f-6";
export var samplesTable = "_5f-8";
export var samplesTableContainer = "_5f-7";
export var statBox = "_5f-a";
export var tableCell = "_5f-1";
export var tableCellCenter = "_5f-2 _5f-1";
export var tableCellRight = "_5f-3 _5f-1";
export var tableHeader = "_5f-0";
export var trackingNumber = "_5f-9";